import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';

/**
 * Variant Definitions
 */
const StyledBidBadgeVariants = {
  success: css`
    height: 20px;
    background: ${({ theme }) => theme.COLORS.BASE};
    color: ${({ theme }) => theme.COLORS.LA_PALMA};
    border: 1px solid ${({ theme }) => theme.COLORS.LA_PALMA};
    font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  `,
  alert: css`
    height: 20px;
    background: ${({ theme }) => theme.COLORS.BASE};
    color: ${({ theme }) => theme.COLORS.MONZA};
    border: 1px solid ${({ theme }) => theme.COLORS.MONZA};
    font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  `,
  disabled: css`
    width: 117px;
    height: 26px;
    background: ${({ theme }) => theme.COLORS.NEUTRAL_50};
    color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
    border: 0;
    font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  `,
  floorMet: css`
    width: 96px;
    border: 1px solid ${({ theme }) => theme.COLORS.LA_PALMA};
    background: ${({ theme }) => theme.COLORS.LA_PALMA};
    color: ${({ theme }) => theme.COLORS.BASE};
    font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};

    &:hover {
      cursor: pointer;
    }
  `,
  hasFloorPrice: css`
    width: 106px;
    border: 1px solid ${({ theme }) => theme.COLORS.DODGER_BLUE};
    color: ${({ theme }) => theme.COLORS.DODGER_BLUE};
    font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};

    &:hover {
      cursor: pointer;
    }
  `,
  closeToFloorPrice: css`
    animation: shake 1s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
    animation-iteration-count: infinite;
    transform: translate3d(0, 0, 0);
    backface-visibility: hidden;
    width: 106px;
    border: 1px solid ${({ theme }) => theme.COLORS.FLUSH_ORANGE};
    color: ${({ theme }) => theme.COLORS.FLUSH_ORANGE};
    font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};

    &:hover {
      cursor: pointer;
    }

    @keyframes shake {
      10%,
      90% {
        transform: translate3d(-2px, -1px, 0);
      }
      20%,
      80% {
        transform: translate3d(1px, 1px, 0);
      }
      30%,
      50%,
      70% {
        transform: translate3d(1px, -1px, 0);
      }
      40%,
      60% {
        transform: translate3d(-2px, 1px, 0);
      }
    }
  `
};

/**
 * Styled Components
 */
const StyledBidBadge = styled.div`
  min-width: min-content;
  background: ${({ theme }) => theme.COLORS.BASE};
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  border: 1px solid ${({ theme }) => theme.COLORS.NEUTRAL_20};
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  border-radius: 17px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  margin: 1px 6px 2px;
  padding: 0 3px;
  z-index: 27;
  word-wrap: normal;
  height: fit-content;
  text-align: center;
  ${({ variant }) => StyledBidBadgeVariants[variant]}
  white-space: nowrap;
`;

/**
 * Prop Validation
 */
StyledBidBadge.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.oneOf([
    'success',
    'alert',
    'disabled',
    'floorMet',
    'hasFloorPrice',
    'closeToFloorPrice'
  ])
};

StyledBidBadge.defaultProps = {
  children: undefined,
  variant: undefined
};

export default StyledBidBadge;
